import { useQuery, useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import { binDBKeys } from "src/pages/binOverview/BinCommander";
import { BaseChartProps } from "src/pages/dashboard/charts/TemperatureCableChart";
import { useMachineAnnotations } from "./useMachineStatusAnnotations";
import { Skeleton } from "antd";
import React from "react";
import { Line } from "react-chartjs-2";
import { generateSubTitle } from "./MoistureDisplayChart";
import { last } from "lodash";
import PremierPlusTapestripDTO from "src/models/PremierPlusTapestripDTO";

interface TemperatureDisplayChartProps extends BaseChartProps {
    tapestrips: PremierPlusTapestripDTO[];
    isLoading: boolean;
}

export const TemperatureDisplayChart : React.FC<TemperatureDisplayChartProps> = (props) => {

    const statusAnnotations = useMachineAnnotations(props.tapestrips);
    
    return <>

        <Skeleton loading={props.isLoading}>
            <section style={{ width: "100%", minHeight: props.chartHeight ?? "50vh" }}>
                {props.tapestrips && <Line options={{
                    scales: {
                        x: {
                            type: "time",
                            //min: value?.[0]?.toISOString(),
                            //max: value?.[1]?.toISOString(),
                            time: {
                                minUnit: 'hour',
                                displayFormats: {
                                }
                            },
                        },
                        y: {
                            type: 'linear',
                            position: 'left',
                            suggestedMin: 0,
                            //suggestedMax: 15.5,
                            ticks: {
                                precision: 0,
                                stepSize: 10,
                            },
                            title: {
                                font: {
                                    size: 16,
                                },
                                display: false,
                            },
                        },
                    },
                    plugins: {
                        legend: {
                            position: 'top' as const,
                            display: true,
                        },
                        title: {
                            display: true,
                            text: 'Temperature Graph',
                        },
                        subtitle: {
                            display: props.tapestrips?.length > 1,
                            text: generateSubTitle(props.tapestrips?.[0]?.captureTimeUtc, last(props.tapestrips)?.captureTimeUtc),
                        },
                        tooltip: {
                            mode: 'index',
                            intersect: false,
                            callbacks: {
                            }
                        },
                        annotation: {
                            annotations: [
                                ...statusAnnotations,
                            ],
                        },
                    },
                }} data={{
                    datasets: [

                        {
                            type: 'line',
                            data: props.tapestrips ?? [], label: "Target Temp", indexAxis: 'x',
                            parsing: {
                                yAxisKey: 'plenumTemperatureSetpointF',
                                xAxisKey: 'captureTimeUtc'
                            },
                            spanGaps: true,
                            backgroundColor: "#2933f2",
                            borderColor: "#2933f2",
                        },
                        {
                            type: 'line',
                            // @ts-ignore - different structure than 1st dataset
                            data: props.tapestrips ?? [],
                            label: "Plenum Temp",
                            indexAxis: 'x',
                            parsing: {
                                yAxisKey: 'actualPlenumTemperatureF',
                                xAxisKey: 'captureTimeUtc'
                            },
                            spanGaps: true,
                            stepped: true,
                            backgroundColor: "#07ff4d",
                            borderColor: "#07ff4d",
                        },
                        {
                            type: 'line',
                            // @ts-ignore - different structure than 1st dataset
                            data: props.tapestrips ?? [],
                            label: "Grain Temp",
                            indexAxis: 'x',
                            parsing: {
                                yAxisKey: 'grainTemperatureF',
                                xAxisKey: 'captureTimeUtc'
                            },
                            spanGaps: true,
                            stepped: true,
                            backgroundColor: "#000000",
                            borderColor: "#000000",
                        },
                    ]
                }} />}
            </section>
        </Skeleton>

    </>;
};